import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useMemo } from 'react';
import ListComponent from '../../List';
var List = function List(_ref) {
  var items = _ref.items,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var listProps = useMemo(function () {
    var finalItems = items.filter(function (item) {
      return item.type === 'li';
    }).map(function (item) {
      var _item$props;
      return (item === null || item === void 0 || (_item$props = item.props) === null || _item$props === void 0 ? void 0 : _item$props.children) || null;
    });
    return _objectSpread({
      items: finalItems
    }, otherProps);
  }, [items, otherProps]);
  return /*#__PURE__*/React.createElement(ListComponent, listProps);
};
export default /*#__PURE__*/memo(List);